import { useState } from "react";
import { getTranslatedText as translate } from "../../components/Localization/Translation";

const initialState = {
  useSharedState: () => {
    const [selectedLaundryIndex, setSelectedLaundryIndex] = useState(1);
    const [selectedOrderIndex, setSelectedOrderIndex] = useState(1);
    const [locale, setLocale] = useState("AR");

    // Service Request Item
    const [serviceRequestCity, setServiceRequestCity] = useState("choose-city");
    const [serviceRequestBuilding, setServiceRequestBuilding] = useState();
    const [serviceRequestFloor, setServiceRequestFloor] = useState();

    // new row
    const [serviceTypesSelect, setServiceTypesSelect] = useState([]);
    const [newItemType, setNewItemType] = useState("");
    const [newServiceTypes, setNewServiceTypes] = useState([]);
    const [newNumberOfItems, setNewNumberOfItems] = useState(1);
    const [newPrice, setNewPrice] = useState(0);
    const [mainPrice, setMainPrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [priceAfterDiscount, setPriceAfterDiscount] = useState(0);
    const [flagPriceOffer, setFlagPriceOffer] = useState(false);
    const [TakeAndGiveCheckbox, setTakeAndGiveCheckbox] = useState(false);
    const [newDetailedOrder, setNewDetailedOrder] = useState([]);

    // Modals Show
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showServiceRequestModal, setShowServiceRequestModal] =
      useState(false);
    const [showLaundryModal, setShowLaundryModal] = useState(false);

    const MyOrdersStatusesAndText = [
      {
        status: "Waiting-Laundry-Accept", // قيد انتظار قبول المغسلة
        text: translate("Waiting-Laundry-Accept", locale),
      },
      {
        status: "Waiting-Delivery-Accept", // قيد انتظار استلام المندوب
        text: translate("Waiting-Delivery-Accept", locale),
      },
      {
        status: "Delivery-Taking-Order-from-user", // قيد الاحضار من العميل
        text: translate("Delivery-Taking-Order-from-user", locale),
      },
      {
        status: "Delivery-Taking-Order-to-Laundry", // قيد الاحضار للمغسلة
        text: translate("Delivery-Taking-Order-to-Laundry", locale),
      },
      {
        status: "Waiting-Laundry-start-washing", // قيد بدء التنفيذ
        text: translate("Waiting-Laundry-start-washing", locale),
      },
      {
        status: "Laundry-start-washing", // قيد التنفيذ
        text: translate("Laundry-start-washing", locale),
      },
      {
        status: "Ready-to-Deliver", // جاهز للتسليم
        text: translate("Ready-to-Deliver", locale),
      },
      {
        status: "Waiting-Delivery-Taking-Accept", // قيد موافقة الاحضار من المندوب
        text: translate("Waiting-Delivery-Taking-Accept", locale),
      },
      {
        status: "Delivery-ReturnBack-Order-from-Laundry", // قيد الاحضار من المغسلة
        text: translate("Delivery-ReturnBack-Order-from-Laundry", locale),
      },
      {
        status: "Delivery-ReturnBack-Order-to-user", // قيد الاحضار للعميل
        text: translate("Delivery-ReturnBack-Order-to-user", locale),
      },
      {
        status: "Delivered-order-to-user", // تم التسليم
        text: translate("Delivered-order-to-user", locale),
      },
    ];

    const MyOrders = [
      {
        id: 1,
        orderNumber: "120",
        LaundryName: "مغسل الحياة",
        DeliveryName: "ثائر الرفاعي",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 2, //one way
        status: MyOrdersStatusesAndText[0].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
          {
            id: 2,
            itemType: "بنطلون",
            serviceTypes: ["كوي", "غسيل"],
            numberOfItems: 5,
            price: "10.0",
          },
          {
            id: 3,
            itemType: "جاكيت",
            serviceTypes: ["كوي"],
            numberOfItems: 2,
            price: "30.0",
          },
          {
            id: 4,
            itemType: "طقم",
            serviceTypes: ["غسيل"],
            numberOfItems: 1,
            price: "20.0",
          },
        ],
      },
      {
        id: 2,
        orderNumber: "90",
        LaundryName: "دوف",
        DeliveryName: "يحيى أحمد",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 1, //one way
        status: MyOrdersStatusesAndText[1].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
        ],
      },
      {
        id: 3,
        orderNumber: "170",
        LaundryName: "مغسل السعودية",
        DeliveryName: "حمادة هلال",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 2, //one way
        status: MyOrdersStatusesAndText[2].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
        ],
      },
      {
        id: 4,
        orderNumber: "103",
        LaundryName: "الأمين",
        DeliveryName: "عبدالله الأبرش",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 1, //one way
        status: MyOrdersStatusesAndText[3].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
        ],
      },
      {
        id: 5,
        orderNumber: "80",
        LaundryName: "مغسل الحياة",
        DeliveryName: "عبدالله الأبرش",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 1, //one way
        status: MyOrdersStatusesAndText[4].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
        ],
      },
      {
        id: 6,
        orderNumber: "87",
        LaundryName: "مغسل الحياة",
        DeliveryName: "عبدالله الأبرش",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 2, //one way
        status: MyOrdersStatusesAndText[5].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
          {
            id: 2,
            itemType: "بنطلون",
            serviceTypes: ["كوي", "غسيل"],
            numberOfItems: 5,
            price: "10.0",
          },
          {
            id: 3,
            itemType: "جاكيت",
            serviceTypes: ["كوي"],
            numberOfItems: 2,
            price: "30.0",
          },
          {
            id: 4,
            itemType: "طقم",
            serviceTypes: ["غسيل"],
            numberOfItems: 1,
            price: "20.0",
          },
        ],
      },
      {
        id: 7,
        orderNumber: "56",
        LaundryName: "مغسل الحياة",
        DeliveryName: "عبدالله الأبرش",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 1, //one way
        status: MyOrdersStatusesAndText[6].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
          {
            id: 2,
            itemType: "بنطلون",
            serviceTypes: ["كوي", "غسيل"],
            numberOfItems: 5,
            price: "10.0",
          },
          {
            id: 3,
            itemType: "جاكيت",
            serviceTypes: ["كوي"],
            numberOfItems: 2,
            price: "30.0",
          },
          {
            id: 4,
            itemType: "طقم",
            serviceTypes: ["غسيل"],
            numberOfItems: 1,
            price: "20.0",
          },
        ],
      },
      {
        id: 8,
        orderNumber: "45",
        LaundryName: "مغسل الحياة",
        DeliveryName: "عبدالله الأبرش",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 2, //one way
        status: MyOrdersStatusesAndText[7].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
          {
            id: 2,
            itemType: "بنطلون",
            serviceTypes: ["كوي", "غسيل"],
            numberOfItems: 5,
            price: "10.0",
          },
          {
            id: 3,
            itemType: "جاكيت",
            serviceTypes: ["كوي"],
            numberOfItems: 2,
            price: "30.0",
          },
          {
            id: 4,
            itemType: "طقم",
            serviceTypes: ["غسيل"],
            numberOfItems: 1,
            price: "20.0",
          },
        ],
      },
      {
        id: 9,
        orderNumber: "72",
        LaundryName: "مغسل الحياة",
        DeliveryName: "عبدالله الأبرش",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 2, //one way
        status: MyOrdersStatusesAndText[8].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
        ],
      },
      {
        id: 10,
        orderNumber: "81",
        LaundryName: "مغسل الحياة",
        DeliveryName: "عبدالله الأبرش",
        done: false,
        date: "الأحد, 20 نوفمبر 2022",
        type: 2, //one way
        status: MyOrdersStatusesAndText[9].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
        ],
      },
      {
        id: 11,
        orderNumber: "60",
        LaundryName: "مغسل النظافة",
        DeliveryName: "عبدالله الأبرش",
        done: true,
        date: "الأحد, 20 نوفمبر 2022",
        type: 1, //one way
        status: MyOrdersStatusesAndText[10].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
        ],
      },
      {
        id: 12,
        orderNumber: "60",
        LaundryName: "مغسل الحياة",
        DeliveryName: "عبدالله الأبرش",
        done: true,
        date: "الأحد, 20 نوفمبر 2022",
        type: 2, //one way
        status: MyOrdersStatusesAndText[10].status,
        cost: "135",
        commision: "10",
        totalPrice: "145",
        detailedOrder: [
          {
            id: 1,
            itemType: "كنزة",
            serviceTypes: ["كوي"],
            numberOfItems: 4,
            price: "20.0",
          },
        ],
      },
    ];

    return {
      selectedLaundryIndex,
      setSelectedLaundryIndex,
      selectedOrderIndex,
      setSelectedOrderIndex,
      locale,
      setLocale,
      MyOrdersStatusesAndText,
      MyOrders,
      showPaymentModal,
      setShowPaymentModal,
      showServiceRequestModal,
      setShowServiceRequestModal,
      showLaundryModal,
      setShowLaundryModal,
      serviceRequestCity,
      setServiceRequestCity,
      serviceRequestBuilding,
      setServiceRequestBuilding,
      serviceRequestFloor,
      setServiceRequestFloor,
      serviceTypesSelect,
      setServiceTypesSelect,
      newItemType,
      setNewItemType,
      newServiceTypes,
      setNewServiceTypes,
      newNumberOfItems,
      setNewNumberOfItems,
      newPrice,
      setNewPrice,
      mainPrice,
      setMainPrice,
      totalPrice,
      setTotalPrice,
      priceAfterDiscount,
      setPriceAfterDiscount,
      flagPriceOffer,
      setFlagPriceOffer,
      newDetailedOrder,
      setNewDetailedOrder,
      TakeAndGiveCheckbox,
      setTakeAndGiveCheckbox,
    };
  },
  userClassify: "Gold",
  AllCities: [
    {
      id: 1,
      name: "الرياض",
    },
    {
      id: 2,
      name: "جدة",
    },
    {
      id: 3,
      name: "مكة المكرمة",
    },
  ],
  AllLaunds: [
    {
      id: 1,
      name: "مغسل الحياة",
      rate: 3.4,
      fav: true,
      freeDelivery: false,
      discount: true,
      discountPercentage: 50,
      phone: "0968820968",
      locate: "جدة",
      services: [
        {
          serviceId: 1,
          itemType: "كنزة",
          servicesOnItem: [
            { serviceOnItemId: 1, serviceName: "غسيل", servicePrice: "20.0" },
            { serviceOnItemId: 2, serviceName: "كوي", servicePrice: "30.0" },
          ],
          serviceWeight: "خفيفة",
        },
        {
          serviceId: 2,
          itemType: "قميص",
          servicesOnItem: [
            { serviceOnItemId: 1, serviceName: "غسيل", servicePrice: "20.0" },
          ],
          serviceWeight: "خفيفة",
        },
        {
          serviceId: 3,
          itemType: "سجاد",
          servicesOnItem: [
            { serviceOnItemId: 1, serviceName: "غسيل", servicePrice: "50.0" },
          ],
          serviceWeight: "ثقيلة",
        },
      ],
    },
    {
      id: 2,
      name: "مغسل الرياض",
      rate: 4.4,
      fav: false,
      freeDelivery: true,
      discount: true,
      discountPercentage: 0,
      phone: "0968820968",
      locate: "الرياض",
      services: [
        {
          serviceId: 1,
          itemType: "كنزة",
          servicesOnItem: [
            { serviceOnItemId: 1, serviceName: "غسيل", servicePrice: "20.0" },
            { serviceOnItemId: 2, serviceName: "كوي", servicePrice: "30.0" },
          ],
          serviceWeight: "خفيفة",
        },
        {
          serviceId: 2,
          itemType: "قميص",
          servicesOnItem: [
            { serviceOnItemId: 1, serviceName: "غسيل", servicePrice: "20.0" },
          ],
          serviceWeight: "خفيفة",
        },
      ],
    },
    {
      id: 3,
      name: "مغسل النظافة",
      rate: 2.4,
      fav: true,
      freeDelivery: false,
      discount: false,
      discountPercentage: 0,
      phone: "0968820968",
      locate: "الدوحة",
      services: [
        {
          serviceId: 1,
          itemType: "كنزة",
          servicesOnItem: [
            { serviceOnItemId: 1, serviceName: "غسيل", servicePrice: "20.0" },
            { serviceOnItemId: 2, serviceName: "كوي", servicePrice: "30.0" },
          ],
          serviceWeight: "خفيفة",
        },
      ],
    },
    {
      id: 4,
      name: "دوف",
      rate: 1.4,
      fav: false,
      freeDelivery: true,
      discount: true,
      discountPercentage: 0,
      phone: "0968820968",
      locate: "الطائف",
      services: [
        {
          serviceId: 1,
          itemType: "قميص",
          servicesOnItem: [
            { serviceOnItemId: 1, serviceName: "غسيل", servicePrice: "20.0" },
          ],
          serviceWeight: "خفيفة",
        },
      ],
    },
    {
      id: 5,
      name: "مغسل الحياة",
      rate: 1.4,
      fav: true,
      freeDelivery: true,
      discount: false,
      discountPercentage: 0,
      phone: "0968820968",
      locate: "المدينة المكرمة",
      services: [],
    },
    {
      id: 6,
      name: "مغسل الحياة",
      rate: 3.4,
      fav: true,
      freeDelivery: false,
      discount: true,
      discountPercentage: 0,
      phone: "0968820968",
      locate: "الرياض",
      services: [],
    },
    {
      id: 7,
      name: "مغسل الحياة",
      rate: 1.4,
      fav: false,
      freeDelivery: false,
      discount: false,
      discountPercentage: 0,
      phone: "0968820968",
      locate: "الرياض",
      services: [],
    },
  ],
  deliveringOrdersTypes: [
    "delivery-two-ways", // 2
    "delivery-one-way", // 1
  ],
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "turn-lang":
      return {
        ...state,
        locale: action.payload,
      };
    default:
      return state;
  }
};

export default rootReducer;
